import "./TestConfigurationAddComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import React, {useEffect, useRef, useCallback} from "react";
import * as Yup from "yup";
import {Formik, FormikProps, FormikValues, Form, Field, FieldProps, FormikHelpers} from "formik";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import {Grid} from "@material-ui/core";
import FormikRadioButtonGroupComponent
    from "../../../../shared/components/core/formik-radio-button-group/formikRadioButtonGroupComponent";
import {CommonService} from "../../../../shared/services";
import FormikSelectDropdownComponent
    from "../../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import _ from "lodash";
import FormikInputComponent from "../../../../shared/components/core/formik-input/FormikInputComponent";
import FormSubTitleWithTooltipComponent
    from "../../../../shared/components/form-sub-title-with-tooltip/FormSubTitleWithTooltipComponent";

interface TestPanelConfigurationAddComponentProps {
    next: Function;
    cancel: Function;
    testID: number;
    prev: Function;
    testDetails: any;
}

const testPanelConfigurationAddFormValidationSchema = Yup.object({
    isStateReportingRequired: Yup.boolean().required("State Reporting is required").nullable(),
    stateReportingUrl: Yup.string(),
    isIntakeFormRequired: Yup.boolean().required("Intake Form is required").nullable(),
    reportingSchedule: Yup.mixed().when('isStateReportingRequired', {
        is: true,
        then: Yup.string().required('Reporting Schedule is Required').nullable(),
    }),
    loincName: Yup.string().when("isStateReportingRequired", {
        is: true,
        then: Yup.string().nullable().required("LOINC Test Name is required")
    }),
    loincCode: Yup.string().when("isStateReportingRequired", {
        is: true,
        then: Yup.string().nullable().required("LOINC Specimen Code is Required")
    }),
    isBulkImportRequired: Yup.boolean().required("State Reporting is required").nullable(),
    // bulkImportTemplate: Yup.mixed().when("isBulkImportRequired", {
    //     is: true,
    //     then: Yup.mixed().nullable().required("Resulting Mode is required"),
    // }),
    // panelResultTemplate: Yup.mixed().required('Required'),
})

interface testPanelConfigurationAddFormSchema {
    // panelResultTemplate: any;
    // bulkImportTemplate: any;
    isIntakeFormRequired: boolean;
    stateReportingUrl: string;
    loincTestName: string;
    loincSpecimenCode: string;
    isStateReportingRequired: boolean;
    reportingSchedule: string;
    isBulkImportRequired: boolean;
}

const FormInitialValues: testPanelConfigurationAddFormSchema = {
    // panelResultTemplate: null,
    stateReportingUrl: "",
    // bulkImportTemplate: null,
    isIntakeFormRequired: false,
    loincTestName: "",
    loincSpecimenCode: "",
    isStateReportingRequired: false,
    reportingSchedule: "",
    isBulkImportRequired: false,
}

const TestConfigurationAddComponent = (props: TestPanelConfigurationAddComponentProps) => {
    const {cancel, next, testID, prev,testDetails} = props;
    const formikRef = useRef<FormikProps<FormikValues>>(null);
    const [testPanelConfigurationAddFormValues, setTestPanelConfigurationAddFormValues] = React.useState<FormikValues>(FormInitialValues);
    // const panelResultTemplateFileRef = useRef<HTMLInputElement | null>(null);
    // const bulkImportTemplateFileRef = useRef<HTMLInputElement | null>(null);

    // const handleTemplateAttachmentUpload = useCallback((fieldName: any, event: any) => {
    //     const file = event?.target?.files[0];
    //     const maxAllowedSize = 5 * 1024 * 1024;
    //     if (event?.target?.files[0].size > maxAllowedSize) {
    //         CommonService._alert.showToast('File size should be under 5MB.', "error");
    //         event.target.value = null;
    //         event.target.files = null;
    //         return;
    //     }
    //     event.target.value = null;
    //     event.target.files = null;
    //
    //     if (fieldName === 'panelResultTemplate') {
    //         if (formikRef.current) {
    //             formikRef.current.setFieldValue('panelResultTemplate', file);
    //         }
    //     } else {
    //         if (formikRef.current) {
    //             formikRef.current.setFieldValue('bulkImportTemplate', file);
    //         }
    //     }
    // }, []);

    const onSubmit = useCallback((values: any, {setSubmitting, setErrors, validateForm}: FormikHelpers<any>) => {
        const payload = _.cloneDeep(values);
        if (!payload.isStateReportingRequired) {
            delete payload.reportingSchedule;
            delete payload.stateReportingUrl;
            delete payload.loincTestName;
            delete payload.loincSpecimenCode;
        }
        payload.status="completed";
        payload.isActive = true;
        setSubmitting(true);
        CommonService._test.editTestDetails(testID, payload)
            .then((response: any) => {
                setSubmitting(false);
                next(response?.data);
            }).catch((error: any) => {
            setSubmitting(false);
            CommonService._alert.showToast(error?.response?.data?.message, 'error');
        })
    }, [next, testID]);

    useEffect(() => {
        if(testDetails){
            setTestPanelConfigurationAddFormValues({
                ...testDetails,
                stateReportingUrl: testDetails?.stateReportingUrl,
                isIntakeFormRequired: testDetails?.isIntakeFormRequired,
                loincTestName: testDetails?.loincName,
                loincSpecimenCode: testDetails?.loincCode,
                isStateReportingRequired: testDetails?.isStateReportingRequired,
                reportingSchedule: testDetails?.reportingSchedule,
                isBulkImportRequired: testDetails?.isBulkImportRequired,
            })
        }
    }, [testDetails]);

    return (
        <div className={'test-panel-configuration-add-screen screen t-form-screen'}>
            <FormTitleWithNavigationBack
                title={'Configuration'}
                tooltipData={"configuration of the test panel"}
                handleClick={prev}
            />
            <div className="t-form">
                <Formik
                    validationSchema={testPanelConfigurationAddFormValidationSchema}
                    initialValues={testPanelConfigurationAddFormValues}
                    validateOnChange={false}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}
                    innerRef={formikRef}
                    onSubmit={onSubmit}
                >
                    {({isSubmitting, values, isValid, setFieldValue, touched, errors, validateForm}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                        }, [validateForm, values]);
                        return (
                            <Form className={"test-panel-configuration-add-holder"}>
                                <div className="t-form-controls-wrapper">
                                    <FormSubTitleWithTooltipComponent title={"Intake Form*"}
                                                                      tooltipData={"Intake Form"}/>
                                    <div className="d-flex align-items-center">
                                        <div className="radio-button-title">Is Intake Form required?</div>
                                        <Field
                                            name={'isIntakeFormRequired'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikRadioButtonGroupComponent
                                                        direction={"row"}
                                                        isValueBoolean={true}
                                                        titleKey={'title'}
                                                        valueKey={'code'}
                                                        options={CommonService._staticData.yesNoOptions}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className={'horizontal-line'}></div>
                                    <FormSubTitleWithTooltipComponent title={"State Reporting*"}
                                                                      tooltipData={"State Reporting"}/>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <div className="d-flex align-items-center">
                                                <div className="radio-button-title">Is State Reporting required ?</div>
                                                <Field name={'isStateReportingRequired'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikRadioButtonGroupComponent
                                                                direction={"row"}
                                                                isValueBoolean={true}
                                                                titleKey={'title'}
                                                                valueKey={'code'}
                                                                options={CommonService._staticData.yesNoOptions}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            {values.isStateReportingRequired &&
                                                <Field name={'reportingSchedule'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikSelectDropdownComponent
                                                                label={'Reporting Schedule'}
                                                                options={CommonService._staticData.reportingScheduleList}
                                                                placeholder={'Select Reporting Schedule'}
                                                                valueKey={'code'}
                                                                required={true}
                                                                getOptionLabel={(option) => (option.title)}
                                                                formikField={field}/>
                                                        )
                                                    }
                                                </Field>
                                            }
                                        </Grid>
                                    </Grid>
                                    {values.isStateReportingRequired && <>
                                        <Field name={'stateReportingUrl'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        label={'State Reporting URL'}
                                                        placeholder={'Enter State Reporting URL'}
                                                        formikField={field}
                                                        required={false}
                                                    />
                                                )
                                            }
                                        </Field>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'loincName'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                fullWidth={true}
                                                                type={'text'}
                                                                label={'LOINC Test Name'}
                                                                placeholder={'Enter LOINC Test Name'}
                                                                formikField={field}
                                                                required={true}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                                <Field name={'loincCode'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'LOINC Specimen Code'}
                                                                fullWidth={true}
                                                                type={'text'}
                                                                placeholder={'Enter LOINC Specimen Code'}
                                                                formikField={field}
                                                                required={true}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </Grid>
                                        </Grid>
                                    </>
                                    }
                                    <div className={'horizontal-line'}></div>
                                    <FormSubTitleWithTooltipComponent title={"Bulk Import*"}
                                                                      tooltipData={"Bulk Import"}/>
                                    <div className="d-flex align-items-center">
                                        <div className="radio-button-title">Is Bulk Import required?</div>
                                        <Field
                                            name={'isBulkImportRequired'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikRadioButtonGroupComponent
                                                        direction={"row"}
                                                        isValueBoolean={true}
                                                        titleKey={'title'}
                                                        valueKey={'code'}
                                                        options={CommonService._staticData.yesNoOptions}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    {/*<Grid container spacing={2} className="pdd-top-15">*/}
                                    {/*    <Grid item xs={12} sm={12} md={6} xl={6}>*/}
                                    {/*        {values.isBulkImportRequired &&*/}
                                    {/*            <div className="attachment-upload-item">*/}
                                    {/*                {!values.bulkImportTemplate ? <>*/}
                                    {/*                        <input type={"file"}*/}
                                    {/*                               className={"display-none"}*/}
                                    {/*                               ref={bulkImportTemplateFileRef}*/}
                                    {/*                               accept={'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}*/}
                                    {/*                               onChange={(event) => {*/}
                                    {/*                                   handleTemplateAttachmentUpload("bulkImportTemplate", event);*/}
                                    {/*                               }}*/}
                                    {/*                        />*/}
                                    {/*                        <Grid container spacing={2}>*/}
                                    {/*                            <Grid item xs={12} sm={6} md={6}>*/}
                                    {/*                                <ButtonComponent*/}
                                    {/*                                    variant={"contained"}*/}
                                    {/*                                    fullWidth={false}*/}
                                    {/*                                    color={'secondary'}*/}
                                    {/*                                    handleClick={() => {*/}
                                    {/*                                        bulkImportTemplateFileRef.current?.click()*/}
                                    {/*                                    }}*/}
                                    {/*                                    startIcon={<FileUploadIcon/>}*/}
                                    {/*                                    type={'button'}>*/}
                                    {/*                                    Upload*/}
                                    {/*                                </ButtonComponent>*/}
                                    {/*                            </Grid>*/}
                                    {/*                            <Grid item xs={12} sm={6} md={6}>*/}
                                    {/*                            </Grid>*/}
                                    {/*                        </Grid>*/}
                                    {/*                        {*/}
                                    {/*                            (_.get(touched, "bulkImportTemplate") && !!(_.get(errors, "bulkImportTemplate"))) &&*/}
                                    {/*                            <ErrorComponent*/}
                                    {/*                                errorText={(_.get(errors, "bulkImportTemplate"))}/>*/}
                                    {/*                        }*/}
                                    {/*                    </>*/}
                                    {/*                    : <>*/}
                                    {/*                        <ChipComponent*/}
                                    {/*                            label={'Bulk Import Template.xls'}*/}
                                    {/*                            onDelete={() => {*/}
                                    {/*                                setFieldValue("bulkImportTemplate", null);*/}
                                    {/*                            }}*/}
                                    {/*                            icon={<AttachFile/>}*/}
                                    {/*                        />*/}
                                    {/*                    </>*/}
                                    {/*                }*/}
                                    {/*            </div>*/}
                                    {/*        }*/}
                                    {/*    </Grid>*/}
                                    {/*</Grid>*/}
                                    {/*<div className={"horizontal-line"}/>*/}
                                    {/*<FormSubTitleWithTooltipComponent title={"Panel Result Template*"}*/}
                                    {/*                                  tooltipData={"Panel Result Template"}/>*/}
                                    {/*<Grid container spacing={2}>*/}
                                    {/*    <Grid item xs={12} sm={12} md={6} xl={6}>*/}
                                    {/*        <div className="attachment-upload-item">*/}
                                    {/*            {!values.panelResultTemplate ? <>*/}
                                    {/*                    <input type={"file"}*/}
                                    {/*                           className={"display-none"}*/}
                                    {/*                           ref={panelResultTemplateFileRef}*/}
                                    {/*                           accept={'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/html'}*/}
                                    {/*                           onChange={(event) => {*/}
                                    {/*                               handleTemplateAttachmentUpload("panelResultTemplate", event);*/}
                                    {/*                           }}*/}
                                    {/*                    />*/}
                                    {/*                    <Grid container spacing={2}>*/}
                                    {/*                        <Grid item xs={12} sm={6} md={6}>*/}
                                    {/*                            <ButtonComponent*/}
                                    {/*                                variant={"contained"}*/}
                                    {/*                                color={"secondary"}*/}
                                    {/*                                fullWidth={false}*/}
                                    {/*                                handleClick={() => {*/}
                                    {/*                                    panelResultTemplateFileRef.current?.click()*/}
                                    {/*                                }}*/}
                                    {/*                                startIcon={<FileUploadIcon/>}*/}
                                    {/*                                type={'button'}>*/}
                                    {/*                                Upload*/}
                                    {/*                            </ButtonComponent>*/}
                                    {/*                        </Grid>*/}
                                    {/*                        <Grid item xs={12} sm={6} md={6}>*/}
                                    {/*                        </Grid>*/}
                                    {/*                    </Grid>*/}
                                    {/*                    {*/}
                                    {/*                        (_.get(touched, "panelResultTemplate") && !!(_.get(errors, "panelResultTemplate"))) &&*/}
                                    {/*                        <ErrorComponent*/}
                                    {/*                            errorText={(_.get(errors, "panelResultTemplate"))}/>*/}
                                    {/*                    }*/}
                                    {/*                </>*/}
                                    {/*                : <>*/}
                                    {/*                    <ChipComponent*/}
                                    {/*                        label={'Result Template.xls'}*/}
                                    {/*                        onDelete={() => {*/}
                                    {/*                            setFieldValue("panelResultTemplate", null);*/}
                                    {/*                        }}*/}
                                    {/*                        icon={<AttachFile/>}*/}
                                    {/*                    />*/}
                                    {/*                </>*/}
                                    {/*            }*/}
                                    {/*        </div>*/}
                                    {/*    </Grid>*/}

                                    {/*    <Grid item xs={12} sm={12} md={6} xl={6}>*/}

                                    {/*    </Grid>*/}
                                    {/*</Grid>*/}
                                </div>
                                <div className="form-action-section">
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"outlined"}
                                        fullWidth={true}
                                        disabled={isSubmitting}
                                        handleClick={cancel}
                                    >
                                        Close
                                    </ButtonComponent>
                                    <ButtonComponent
                                        type="submit"
                                        color={"primary"}
                                        variant={"contained"}
                                        fullWidth={true}
                                        disabled={!isValid}
                                        isLoading={isSubmitting}
                                    >
                                        Next
                                    </ButtonComponent>
                                </div>
                            </Form>
                        )
                    }}
                </Formik>
            </div>
        </div>
    );

};

export default TestConfigurationAddComponent;
